<div class="container-badge" tabindex="0">
  <div
    role="status"
    [attr.aria-label]="'Isto é um ícone de notificação, existe  : ' + resultCounter + ' de notificações '"
    [matBadge]="resultCounter"
    [ngClass]="{ 'badge-secondary': secondary }">
    <ng-container *ngIf="icon; else noIcon">
      <mat-icon>{{ icon }}</mat-icon>
    </ng-container>
    <ng-template #noIcon>
      <ng-content></ng-content>
    </ng-template>
  </div>
</div>
